import {reactive} from 'vue';

export const flowState = reactive({
    headSelected: false,
    managerSelected: false,
});

export function setHeadSelected(value) {
    flowState.headSelected = value;
}

export function setManagerSelected(value) {
    flowState.managerSelected = value;
}
